import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListByLevelPayload } from '@app-store/slices/sourceCategories/listByLevel'

interface TaskAction extends Action {
    payload: IListByLevelPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sourceCategories.listByLevel

// This saga is for getting list of companies
function* listByLevelSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(
            `/companies/source-categories/${payload.categoryId}/sub-categories/${payload.level}`
        )
        if (response.success) {
            yield put(onSuccess({ ...response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listByLevelSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listByLevelSagaTask)
}

export default listByLevelSaga
